import React from 'react';
import { platforms } from '../mock/platformsData';
import PartnersCarousel from './PartnersCarousel';
import { siAppstore, siGoogledisplayandvideo360 } from 'simple-icons/icons';

const PlatformsSection = () => {
  // 👉 Ruta de los logos del carrusel (ajusta los nombres si los tuyos son distintos)
  const logos = [
    '/img/carrusel/carrusel1.png',
    '/img/carrusel/carrusel2.png',
    '/img/carrusel/carrusel3.png',
    '/img/carrusel/carrusel4.png',
    '/img/carrusel/carrusel5.jpg',
  ];

  // Duplicamos para efecto infinito
  const loopLogos = [...logos, ...logos];

  return (
    <section className="py-20 bg-white">
      {/* Keyframes locales para el carrusel */}
      <style>{`
        @keyframes slideSlow {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>

      <div className="container mx-auto px-6">
        {/* Título principal */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-stepsblue mb-4">
            Nuestras Plataformas
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Soluciones tecnológicas especializadas para cada necesidad de negocio.
          </p>
        </div>

        {/* Cards de plataformas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {platforms.map((platform) => (
            <div
              key={platform.id}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow border-t-4 border-stepsblue"
            >
              <div className="w-16 h-16 mb-6">
                <img
                  src={platform.logo}
                  alt={platform.name}
                  className="w-full h-full object-contain rounded-full border-2 border-stepsblue shadow-sm"
                />
              </div>

              <h3 className="text-xl font-bold text-gray-800 mb-3">{platform.name}</h3>
              <p className="text-gray-600 mb-6">{platform.description}</p>

              {/* Redes */}
              <div className="flex space-x-4">
                <a
                  href={platform.social.web}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-stepsblue transition-colors"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                </a>
                <a
                  href={platform.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-[#3b5998] transition-colors"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                  </svg>
                </a>
                <a
                  href={platform.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-[#e1306c] transition-colors"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069z" />
                  </svg>
                </a>
              </div>

              {/* Extra links solo para TiMi (con latido + tooltip) */}
              {platform.name === 'TiMi App' && platform.extraLinks && (
                <div className="flex gap-4 mt-4 justify-center flex-wrap">
                  {platform.extraLinks.map((link, index) => (
                    <a
                      key={index}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="relative group"
                    >
                      <span
                        className="w-6 h-6 inline-block group-hover:animate-heartbeat"
                        dangerouslySetInnerHTML={{
                          __html: (link.type === 'play' ? siGoogledisplayandvideo360.svg : siAppstore.svg)
                            .replace(/<title>.*?<\/title>/g, '')
                        }}
                      />
                      <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-transform bg-black text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                        {link.tooltip}
                      </span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Título “Nuestros Colaboradores” con estilos del template */}
        <div className="text-center mb-8">
          <p className="uppercase text-stepsblue font-semibold tracking-wide">Nuestros</p>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-800">Colaboradores</h3>
          <div className="w-12 h-0.5 bg-stepsblue mx-auto mt-3"></div>
        </div>

        {/* Carrusel de logos */}
        <div className="relative overflow-hidden py-6">
          <div
            className="flex items-center gap-10"
            style={{
              width: '200%',
              animation: 'slideSlow 30s linear infinite',
            }}
          >
            {loopLogos.map((src, i) => (
              <div key={`${src}-${i}`} className="flex-none w-48 h-24">
                <img
                  src={src}
                  alt={`colaborador-${i}`}
                  className="w-full h-full object-contain opacity-80 hover:opacity-100 transition"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Si sigues usando tu carrusel antiguo para partners, puedes dejarlo o quitarlo */}
        {/* <PartnersCarousel /> */}
      </div>
    </section>
  );
};

export default PlatformsSection;
